<template>
  <section class="network-sec">
    <div class="network-sec__banner">
      <TopBanner class="mb-16" :item="banner" />
    </div>

    <div class="container _py-16 _py-md-12" v-if="getWebinarsList !== null">
      <AppBtnBreadCrumb class="_mb-4" />
      <div class="sections__list d-grid row-1-1 gap-32">
        <VideoCard
          @like="likeWebinar"
          @favorite="favoriteWebinar"
          @downloadFile="downloadFile"
          @viewItem="viewItem"
          @setVideoProgress="setVideoProgress"
          v-for="(block, ind) in filteredWebinarsList"
          :key="filteredWebinarsList.length + ind"
          :item="getTranslate(block)"
        >
        </VideoCard>
      </div>
    </div>
    <div class="d-flex justify-center _my-6" v-else>
      <Preloader />
    </div>
    <OtherMain :items="sectionsList" :analyticEventPrefix="'distribution_'">
      <template v-slot:title>
        <div
          class="section-detail__title _fs-32 _lh-38 _fs-sm-24 _lh-sm-32 _fw-600"
        >
          {{ $t("another_sections_title") }}
        </div>
      </template>
    </OtherMain>
  </section>
</template>

<script>
import TopBanner from "@/components/UI/banners/TopBanner";
import VideoCard from "@/components/UI/cards/VideoCard";
import AppBtnBreadCrumb from "@/components/UI/buttons/AppBtnBreadCrumb";
import download from "@/mixins/download";
import OtherMain from "@/components/UI/OtherMain";
import Preloader from "@/components/UI/Preloader";

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  metaInfo() {
    return { title: this.$t("interface.menu.network_security") };
  },
  name: "NetworkSecurity",
  components: {
    TopBanner,
    VideoCard,
    AppBtnBreadCrumb,
    OtherMain,
    Preloader,
  },
  mixins: [download],
  data: () => ({
    stateMaterials: false,
    currentMaterials: null,
    materialsWebinarId: null,
    currentLinks: null,
  }),
  computed: {
    ...mapGetters(["Sections", "getWebinarsList"]),
    filteredWebinarsList() {
      if (this.$route.params.filtered) {
        return this.getWebinarsList.filter((el) => !el.view).length
          ? this.getWebinarsList.filter((el) => !el.view)
          : this.getWebinarsList;
      } else {
        return this.getWebinarsList;
      }
    },
    sectionsList() {
      const vm = this;
      return this.$t("another_sections") &&
        Array.isArray(this.$t("another_sections"))
        ? this.$t("another_sections")
            .filter((el) => !el.hide)
            .map(function (el) {
              return {
                ...el,
                image: require(`@/assets/img/sections/${el.image}`),
                route: vm.helpers.buildRoute(el.route),
              };
            })
            .filter((el) => el.route.name !== this.$route.name)
        : null;
    },
    currentLocale() {
      return this.Trans.currentLocale;
    },
    filteredList() {
      return this.$t("pages.network_security.items").map(function (el) {
        return {
          ...el,
          preview: require(`@/assets/img/network-security/${el.preview}`),
        };
      });
    },
    banner() {
      return {
        title: this.$t("pages.network_security.title"),
        descr: this.$t("pages.network_security.description"),
        theme: "dark",
        images: [
          {
            src: require("@/assets/img/banners/network-security/NS-mob.jpg"),
            media: "(max-width: 743px)",
          },
          {
            src: require("@/assets/img/banners/network-security/NS-tab.jpg"),
            media: "(max-width: 1220px)",
          },
          {
            src: require("@/assets/img/banners/network-security/NS-1440.jpg"),
            media: "(max-width: 1919px)",
          },
          {
            src: require("@/assets/img/banners/network-security/NS-1920.jpg"),
            media: "(min-width: 1920px)",
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions([
      "fetchWebinarsList",
      "WebinarsSetLike",
      "WebinarsSetFavorite",
      "WebinarsSetVideoProgress",
      "WebinarsMaterialSetLike",
      "WebinarsMaterialSetFavorite",
      "WebinarsLinkSetLike",
      "WebinarsLinkSetFavorite",
      "WebinarsSetView",
    ]),
    ...mapMutations(["setWebinarsList"]),
    getTranslate(item) {
      return {
        ...item,
        title: item.translates[0].title,
        description: item.translates[0].description,
        preview: item.translates[0].preview,
        file: item.translates[0].file || item.translates[0].file_link,
        file_size: item.translates[0].file_size,
        speakers: item.translates[0].speakers,
        materials: item.translates[0].materials,
        links: item.translates[0].links,
        extras: item.translates[0].extras,
      };
    },
    async updateList() {
      await this.fetchWebinarsList({
        lang: this.currentLocale,
        type: "network_security",
      });
    },
    async likeWebinar(id) {
      await this.WebinarsSetLike(id);
      await this.updateList();
    },
    async favoriteWebinar(id) {
      await this.WebinarsSetFavorite(id);
      await this.updateList();
    },
    async setVideoProgress(id, time) {
      await this.WebinarsSetVideoProgress({
        id: id,
        progress: Math.round(time),
      });
      await this.updateList();
    },
    async viewItem(id) {
      await this.WebinarsSetView(id);
      await this.updateList();
    },
  },
  async mounted() {
    await this.fetchWebinarsList({
      lang: this.currentLocale,
      type: "network_security",
    });
  },
  destroyed() {
    this.setWebinarsList(null);
  },
};
</script>

<style lang="scss">
.network-sec {
  &__banner {
    background-color: #FFFACB;
  }

  .top-banner {
    max-width: 1920px;
    margin: 0 auto;
  }
}
.row-1-1 {
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 1220px) {
    grid-template-columns: 1fr;
  }
}

.gap-32 {
  grid-gap: 32px;
}
</style>
